import React from "react";
// @ts-ignore antd v4 doesn't have theme
import { theme as antdTheme } from "antd";
import { generateCssVars as defaultGenerateCssVars } from "../../utils/theming";
var CssVarsProvider = function CssVarsProvider(_ref) {
  var _config$settings$them, _config$settings$desi, _antdTheme$useToken;
  var children = _ref.children,
    config = _ref.config;
  var ref = /*#__PURE__*/React.createRef();
  var themeMode = (_config$settings$them = config.settings.themeMode) !== null && _config$settings$them !== void 0 ? _config$settings$them : "light";
  var compactMode = !!config.settings.compactMode;
  var renderSize = config.settings.renderSize;
  var liteMode = config.settings.liteMode;
  var enableCssVars = !!((_config$settings$desi = config.settings.designSettings) !== null && _config$settings$desi !== void 0 && _config$settings$desi.generateCssVarsFromThemeLibrary);
  var _ref2 = (_antdTheme$useToken = antdTheme === null || antdTheme === void 0 ? void 0 : antdTheme.useToken()) !== null && _antdTheme$useToken !== void 0 ? _antdTheme$useToken : {},
    token = _ref2.token,
    theme = _ref2.theme; // antd v4 doesn't have theme

  React.useEffect(function () {
    var cssVarsTarget = ref.current;
    var cssVars = {};
    if (enableCssVars) {
      var _config$settings$desi2, _config$settings$desi3;
      var generateCssVars = (_config$settings$desi2 = (_config$settings$desi3 = config.settings.designSettings) === null || _config$settings$desi3 === void 0 || (_config$settings$desi3 = _config$settings$desi3.generateCssVars) === null || _config$settings$desi3 === void 0 ? void 0 : _config$settings$desi3.antd) !== null && _config$settings$desi2 !== void 0 ? _config$settings$desi2 : defaultGenerateCssVars;
      cssVars = generateCssVars.call(config.ctx, token, config);
      for (var k in cssVars) {
        if (cssVars[k] != undefined) {
          cssVarsTarget === null || cssVarsTarget === void 0 || cssVarsTarget.style.setProperty(k, cssVars[k]);
        }
      }
    }
    return function () {
      for (var _k in cssVars) {
        cssVarsTarget === null || cssVarsTarget === void 0 || cssVarsTarget.style.removeProperty(_k);
      }
    };
  }, [themeMode, renderSize, ref, theme === null || theme === void 0 ? void 0 : theme.id, config, enableCssVars]);
  return /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: "qb-antd qb-".concat(themeMode, " ").concat(compactMode ? "qb-compact" : "", " ").concat(liteMode ? "qb-lite" : "")
  }, children);
};
export { CssVarsProvider };